import { render, staticRenderFns } from "./MomentSoldFFListComponent.vue?vue&type=template&id=094390bf&scoped=true&"
import script from "./MomentSoldFFListComponent.vue?vue&type=script&lang=ts&"
export * from "./MomentSoldFFListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MomentSoldFFListComponent.vue?vue&type=style&index=0&id=094390bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094390bf",
  null
  
)

export default component.exports